import React from 'react';
import type {
  IProGalleryProps,
  IProGalleryImperativeActions,
} from '../../../ProGallery.types';
import ProGalleryCommon from '../../ProGalleryCommon';
import styles from './ProGallery.scss';

const ProGallerySkin: React.ForwardRefRenderFunction<
  IProGalleryImperativeActions,
  IProGalleryProps
> = (props, ref) => {
  return <ProGalleryCommon {...props} skinClasses={styles} ref={ref} />;
};

export default React.forwardRef(ProGallerySkin);
